import React from "react";
import { RequirePermission } from "./RequirePermission";

export function RequireSuperAdmin({ children }: { children: React.ReactNode }) {
  return (
    <RequirePermission moduleId="advancedTools" level="manage" message="This area is restricted to Super Admin access.">
      {children}
    </RequirePermission>
  );
}
